import apiClient from '../apiClient'
import { trackEvent } from '@/utils/tracking'

const getMyConversations = async () => {
    try {
        const response = await apiClient.post(
            '/conversations/myconversations',
            {}
        )
        const conversations = response.data
        return conversations || []
    } catch (error) {
        console.log('Failed to retrieve user conversations: ' + error.message)
        return []
    }
}

const getConversation = async (conversationId) => {
    try {
        const response = await apiClient.get(`/conversations/${conversationId}`)
        const conversations = response.data
        if (Array.isArray(conversations) && conversations.length > 0) {
            return conversations[0]
        } else {
            return conversations
        }
    } catch (error) {
        console.log('Failed to retrieve conversation: ' + error.message)
        return null
    }
}

const createConversation = async (receiverUsername) => {
    try {
        const response = await apiClient.post('/conversations', {
            receiverUsername: receiverUsername,
        })
        trackEvent('Conversation Created', {
            receiverUsername: receiverUsername,
        })
        return response.data
    } catch (error) {
        console.log('error creating conversation', error)
        throw error
    }
}

const approveConversation = async (conversationId) => {
    try {
        const response = await apiClient.post('/conversations/approve', {
            conversationId: conversationId,
        })
        if (response.data.message === 'Conversation approved') {
            return { success: true, conversation: response.data.conversation }
        } else {
            return { success: false }
        }
    } catch (error) {
        console.error('Failed to approve conversation: ' + error.message)
        throw error
    }
}

const favoriteConversation = async (conversationId) => {
    try {
        const response = await apiClient.post('/conversations/favorite', {
            conversationId: conversationId,
        })
        if (response.data.message === 'Conversation favorited') {
            return { success: true, conversation: response.data.conversation }
        } else {
            return { success: false }
        }
    } catch (error) {
        console.error('Failed to favorite conversation: ' + error.message)
        throw error
    }
}

const unfavoriteConversation = async (conversationId) => {
    try {
        const response = await apiClient.post('/conversations/unfavorite', {
            conversationId: conversationId,
        })
        if (response.data.message === 'Conversation unfavorited') {
            return { success: true, conversation: response.data.conversation }
        } else {
            return { success: false }
        }
    } catch (error) {
        console.error('Failed to unfavorite conversation: ' + error.message)
        throw error
    }
}

const leaveConversation = async (conversationId) => {
    try {
        const response = await apiClient.post('/conversations/leave', {
            conversationId: conversationId,
        })
        if (response.data.message === 'Conversation deleted for user') {
            return { success: true }
        } else {
            return { success: false }
        }
    } catch (error) {
        console.error('Failed to leave conversation: ' + error.message)
        throw error
    }
}

// Removed unused API: updateParticipantDetails

export default {
    createConversation,
    getMyConversations,
    getConversation,
    approveConversation,
    favoriteConversation,
    unfavoriteConversation,
    leaveConversation,
}
